/* ──────────────────────────────────────────────────────────────
   Helper global para mostrar toasts con notistack
   ────────────────────────────────────────────────────────────── */
import React from 'react';
import { useSnackbar, VariantType, OptionsObject } from 'notistack';

/* ref mut-able donde guardaremos la función real de notistack */
let snackbarRef: (msg: React.ReactNode, opts?: OptionsObject) => void;

/** Componente “fantasma” que solo registra la ref una vez */
export const SnackbarUtilsConfigurator: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  snackbarRef = enqueueSnackbar; // ← queda disponible globalmente
  return null; // no renderiza nada
};

/** Función que puedes importar desde cualquier sitio */
export function enqueueSnackbar(
  msg: React.ReactNode,
  opts: OptionsObject = { variant: 'default' as VariantType },
) {
  if (snackbarRef) {
    snackbarRef(msg, opts);
  } else {
    /* Muy raro: se llamó antes de montar <SnackbarUtilsConfigurator/> */
  }
}
